/**
 * Phase grouping for the read-only Work board (spec 2026-10-28, "Client Work
 * view shows the portal lifecycle read-only").
 *
 * The order and labels are a client-side rendering decision, not a server
 * rule - `ClientPhase` itself (what stage maps to what phase) is the server's
 * one source of truth (`clientLifecycle` in work-stage.ts). Typing this
 * array against `ClientPhase` means an added or renamed phase fails this
 * project's typecheck rather than silently falling off the board.
 *
 * @module web/screens/app/board/phases
 */
import type { ClientPhase, ClientWorkItem } from "../../../api/types.ts";

export const PHASE_ORDER: readonly ClientPhase[] = [
  "briefing_received",
  "looking_for_editor",
  "in_production",
  "in_revision",
  "delivered",
];

export const PHASE_LABELS: Record<ClientPhase, string> = {
  briefing_received: "Briefing received",
  looking_for_editor: "Looking for an editor",
  in_production: "In production",
  in_revision: "In revision",
  delivered: "Delivered",
};

export interface PhaseColumn {
  phase: ClientPhase;
  label: string;
  items: ClientWorkItem[];
}

/** Every phase, in display order, each holding the items currently in it. */
export function groupByPhase(items: readonly ClientWorkItem[]): PhaseColumn[] {
  return PHASE_ORDER.map(phase => ({
    phase,
    label: PHASE_LABELS[phase],
    items: items.filter(i => i.phase === phase),
  }));
}
